import React from 'react'
import {
  Box,
  Grid,
  IconButton,
  TextField,
  FormControl,
  FormHelperText,
} from '@mui/material';
import { useFormikContext, getIn } from "formik";
import DeleteIcon from '@mui/icons-material/Delete';
import MultiUploadComponent from '../common/form/MultiUploadComponent';


const NoticeFileMultiForm = ({ file, index, touched, errors, handleRemove, handleChange, handleBlur }) => {
  const formikProps = useFormikContext();

  const fileVal = `files[${index}].file`;
  const touchedFile = getIn(touched, fileVal);
  const errorFile = getIn(errors, fileVal);

  const fileDesc = `files[${index}].fileDesc`;
  const touchedFileDesc = getIn(touched, fileDesc);
  const errorFileDesc = getIn(errors, fileDesc);

  return (
     <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        marginTop: 2,
        px: 2,
      }}

    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >

        <Grid item xs={5}>
          <MultiUploadComponent index={index} formik={formikProps} />
          {touchedFile && Boolean(errorFile) && (
            <FormControl error>
              <FormHelperText>
                {touchedFile && errorFile}
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid item xs={6}>
          <TextField
            variant="standard"
            fullWidth
            name={fileDesc}
            id={fileDesc}
            value={formikProps.values.files[index].fileDesc}
            helperText={
              touchedFileDesc && errorFileDesc
                ? errorFileDesc
                : ""
            }
            error={Boolean(touchedFileDesc && errorFileDesc)}
            onChange={handleChange}
            onBlur={handleBlur}
            label="참고사항"

          />
        </Grid>
        <Grid item xs={1}><IconButton aria-label="delete" onClick={handleRemove}><DeleteIcon /></IconButton></Grid>
      </Grid>

    </Box>
  )
}

export default NoticeFileMultiForm